// Device id helper shared by App.js boot and Login.js post-login.
//
// crypto.randomUUID() is only exposed on secure contexts (HTTPS or
// localhost). Reaching the dev server over a Tailscale IP / LAN IP / ngrok
// http tunnel breaks the call on iOS Safari and older Android browsers.
// crypto.getRandomValues IS available everywhere, so we build a v4 UUID
// from random bytes when the convenience API isn't there.

const fallbackUuidV4 = () => {
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    // RFC 4122 §4.4: set version + variant bits.
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0'));
    return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex.slice(6, 8).join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10, 16).join('')}`;
  }
  // Last-resort fallback for very old browsers / non-browser contexts. The
  // id is just used to identify a device for session tracking — not
  // security-sensitive — so weaker entropy is acceptable here.
  return `${Date.now().toString(16)}-${Math.random().toString(16).slice(2, 10)}-${Math.random().toString(16).slice(2, 14)}`;
};

const safeRandomUUID = () => {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
  } catch (e) { /* fall through */ }
  return fallbackUuidV4();
};

export const getDeviceId = () => {
  let id = localStorage.getItem('device_id');
  if (!id) {
    id = safeRandomUUID();
    localStorage.setItem('device_id', id);
  }
  return id;
};
